
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","baseProfile":"tiny","version":"1.2","viewBox":"0 0 567 580"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M116.8 193.1c79.9-7.9 153.8 34.7 121.5 123.2-15.2 45.6-43.8 101-67.8 142.9-20.4 35.5-49.1 90.9-90.7 103.3-54.1 16.1-79.2-31.3-60.5-77.7 8.5-21.1 27.8-41.2 44.6-56.6 42.3-39 81.6-70.4 124.2-109.2 41-37.4 27.5-93.3-36.1-72.8-30.4 9.8-52.6 34.2-87.2 27.6-17-3.2-30.4-16.7-28-34.7 4.4-32.4 52.3-44.2 80.1-46.1z","fill":"#ff4081"}}),_c('path',{attrs:{"d":"M323.5 274.2c26.7-2.9 58 13.3 82.4 23.9 38.4 16.6 116.6 56.2 140.2 92.7 15.9 24.6 5.3 55.4-20.5 61.9-32.2 5.5-52.7-13.3-73-33.7-31.1-31.3-61.1-70.4-90.3-101-32-30.5-67.3-18-55.4 24.7 7 25 35.9 54 17.1 81.2-13.5 19.5-37.2 9.7-47.4-8.4-23.2-41-13.4-135.9 46.8-141.2zM282.8 192.4c-26.7 2.9-62.4-16.5-86.8-27-38.4-16.6-111.2-54.2-132.7-87.5C47.4 53.3 51.6 19.5 83.8 14s52.7 14.6 72.2 34.3c29.6 29.8 60.3 71.6 91.7 102.7 24.8 26.6 65.6 17.5 53.6-25.2-7-25-37.6-58.3-16.6-84.6 15.4-19.2 36.5-6.9 45.6 10.6 22.9 44.2 15.2 133.7-47.5 140.6z","fill":"#6a1ebb"}}),_c('path',{attrs:{"d":"M370.4 220.7c17.5 18.1 50.6-12.2 68.8-14 13.3-1.3 29.6 3.9 29.2 20.1 0 26.4-48.3 30.3-68 28.4-38.1-3.8-65.6-28.5-51.7-70.4 11.6-35.1 49.4-116.1 77.7-139 30.2-24.5 66.1-5.9 54.4 32.5-8.7 28.6-67.7 70.3-91.7 92.5-12.7 11.7-33.4 33.3-18.8 49.9z","fill":"#ff4081"}})])
          )
        }
      }
    